import React from "react";
import BackofficeLayout from "./BackofficeLayout";

const BackofficeIndex = () => {
  return (
    <BackofficeLayout>
      <div className="flex justify-center items-center min-h-[400px] p-6">
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm w-full h-[calc(100vh-150px)]">
          <div className="text-center h-full flex flex-col justify-center items-center">
            <h1 className="text-4xl font-bold mb-4">Uptime - Backoffice</h1>
            <p className="text-gray-600">
              Selecione uma opção no menu acima para gerenciar consultores ou falhas.
            </p>
          </div>
        </div>
      </div>
    </BackofficeLayout>
  );
};

export default BackofficeIndex;
